import stringifyAttributes from '../helpers/stringifyAttributes';

export default function () {
    return {
        restrict: 'E',
        template(el, attrs) {
            const children = el[0].textContent;
            const propsString = stringifyAttributes(attrs);

            return `
                <label class="pointer">
                    <input class="hide" type="checkbox" ${ propsString }/>
                    <i class="icon material-icons unchecked">&#xE835;</i>
                    <i class="icon material-icons checked hide">&#xE834;</i>
                    ${ children }
                </label>
            `;
        }
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/directives/checkbox.js